import { ThemeDefinition, createVuetify } from "vuetify";
import {
  VApp,
  VCard,
  VCardText,
  VCol,
  VRow,
  VContainer,
  VAppBar,
  VAppBarTitle,
  VDivider,
} from "vuetify/components";
import * as directives from "vuetify/directives";
// import colors from "vuetify/lib/util/colors";

const technoZTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: "#4BAF2D",
    secondary: "#F5B4B4",
    background: "#FFFFFF",
    surface: "#FFFFFF",
    footer: "#000000",
    error: "#B00020",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
    floorplanTitle: "#A8A8A8",
    calendarLineColor: "#a8a8a8",
    booked: "#FF8989",
  },
};

const ukoTowerTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: "#80f1df",
    secondary: "#F5B4B4",
    background: "#000000",
    surface: "#000000",
    error: "#B00020",
    footer: "#565656",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FB8C00",
    floorplanTitle: "#FFFFFF",
    calendarLineColor: "#FFFFFF",
    booked: "#FF8989",
  },
};

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    components: {
      VCard,
      VCardText,
      VRow,
      VCol,
      VApp,
      VContainer,
      VAppBar,
      VAppBarTitle,
      VDivider,
    },
    directives,
    ssr: true, // make it false if do not need server side rendering
    theme: {
      defaultTheme: "technoZTheme",
      themes: {
        technoZTheme,
        ukoTowerTheme,
      },
    },
  });
  nuxtApp.vueApp.use(vuetify);
});
